import React from 'react'

function HomeBox8() {
    return (
        <div className='homebox2main'>
            <div className='container'>
                <div className='homebox2'>
                    <div className='homebox2-right'>
                        <span>Made to keep your business moving</span>
                        <h2>Powerful loyalty management for busy teams</h2>
                        <p>Loyalific gives small businesses the tools to manage loyalty programs faster, smarter, and with minimal effort.</p>
                        <ul>
                            <li>Reward customers instantly through the Stamper App</li>
                            <li>Oversee staff users and business locations centrally</li>
                            <li>Automatically send reward updates, reminders, and messages</li>
                        </ul>
                    </div>

                    <div className='homebox2-left'>
                        <img src="/image 11.png" alt="box8-img" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeBox8